import importscript from "../../javascript/import-script.js";
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/attributes/val/val.js";

export default obj => {
	if (obj.length) {
		const key = obj.data("recaptcha");
		if (key) {

			// attach immediately so in front of other submit handlers
			obj.each(function () {
				const input = $(this),
					form = input.closest("form");

				// track which submit button was pressed
				let button,
					selector = "input[type=submit],button[name]:not([type=button]):not([type=reset])",
					submitted = false;
				$(selector, form).on("click", function () {
					button = this;
				});

				// submit the form
				form.on("submit", function (e) {
					if (!submitted) {
						submitted = true;
						grecaptcha.ready(() => {
							grecaptcha.execute(key, {action: "submit"}).then(token => {
								input.val(token);
								this.requestSubmit(button); // resubmit the form with the button that was originally clicked
								submitted = false;
							});
						});
						e.stopImmediatePropagation(); // prevent all other handlers from firing whilst we check the recaptcha
						e.preventDefault();
					}
				});
			});

			// load the script
			importscript("https://www.google.com/recaptcha/api.js?render=" + key);
		}
	}
}
